import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import LocalizedImage from '@LocalizedImage';
import {
  HELP_TOPIC_ART_SIZE_POSITION_STB_LINES,
  HELP_TOPIC_ART_SIZE_POSITION_STRETCHED,
  HELP_TOPIC_ART_SIZE_POSITION_OPTIMIZED,
  HELP_TOPIC_ART_SIZE_POSITION_FLATTENED,
  HELP_TOPIC_ART_SIZE_POSITION_ADJUSTED,
  HELP_ART_SIZE_LABELS,
  HELP_SECTION_SAFETY_TRIM_AND_BLEED,
} from '@app/constants';
import { setLabelTypePart } from '@app/utils/help';

const SafetyTrimAndBleed = ({ activeTopic, scrollToTopic, isKnownShapeSticker, isCustomShapeSticker, isSheetFlow, isDesignIn }) => {
  const labelTypePart = setLabelTypePart(HELP_ART_SIZE_LABELS, [isCustomShapeSticker, isKnownShapeSticker, isSheetFlow, isDesignIn]);

  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_SAFETY_TRIM_AND_BLEED} className="help-section">
      {!isCustomShapeSticker && (
        <div id={HELP_TOPIC_ART_SIZE_POSITION_STB_LINES} className={isDesignIn ? 'help-section' : 'section-topic'}>
          <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines`} tagName={isDesignIn ? 'h2' : 'h3'} />
          <div>
            <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines-p1`} tagName="p" />
            <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines-p2`} tagName="p" />
            <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines-p3`} tagName="p" />
            <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines-p4`} tagName="p" />
            <div className="image-block image-art-position">
              <LocalizedImage name="art-position-stb-lines.png" alt="Safe, trim & bleed lines example" allowDefault={true} />
            </div>
            <LocalizedText id={`qau-help-topic-${labelTypePart}-stb-lines-note`} tagName="p" />
          </div>
        </div>
      )}
      {!isSheetFlow && (
        <div id={HELP_TOPIC_ART_SIZE_POSITION_STRETCHED} className="section-topic">
          <LocalizedText id={`qau-help-topic-${labelTypePart}-art-stretched`} tagName="h3" />
          <div>
            <LocalizedText id={`qau-help-topic-${labelTypePart}-art-stretched-p1`} tagName="p" />
            {isCustomShapeSticker && <LocalizedText id={`qau-help-topic-${labelTypePart}-art-stretched-p2`} tagName="p" />}
          </div>
        </div>
      )}
      <div id={HELP_TOPIC_ART_SIZE_POSITION_OPTIMIZED} className="section-topic">
        <LocalizedText id={`qau-help-topic-${labelTypePart}-art-optimized`} tagName="h3" />
        <div>
          <LocalizedText id={`qau-help-topic-${labelTypePart}-art-optimized-p1`} tagName="p" />
          {!isCustomShapeSticker && <LocalizedText id={`qau-help-topic-${labelTypePart}-art-optimized-p2`} tagName="p" />}
        </div>
      </div>
      <div id={HELP_TOPIC_ART_SIZE_POSITION_FLATTENED} className="section-topic">
        <LocalizedText id={`qau-help-topic-${labelTypePart}-art-flattened`} tagName="h3" />
        <div>
          <LocalizedText id={`qau-help-topic-${labelTypePart}-art-flattened-p1`} tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_ART_SIZE_POSITION_ADJUSTED} className="section-topic">
        <LocalizedText id={`qau-help-topic-${labelTypePart}-art-adjusted`} tagName="h3" />
        <div>
          <LocalizedText id={`qau-help-topic-${labelTypePart}-art-adjusted-p1`} tagName="p" />
          {isCustomShapeSticker && <LocalizedText id={`qau-help-topic-${labelTypePart}-art-adjusted-p2`} tagName="p" />}
        </div>
      </div>
    </div>
  );
};

SafetyTrimAndBleed.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  activeTopic: PropTypes.string,
  isKnownShapeSticker: PropTypes.bool.isRequired,
  isCustomShapeSticker: PropTypes.bool.isRequired,
  isSheetFlow: PropTypes.bool.isRequired,
  isDesignIn: PropTypes.bool.isRequired,
};

export default SafetyTrimAndBleed;
